module.exports = __webpack_public_path__ + "media/images/new-ui-images/drag-drop-6c3db86c02a16a28ed6967541f31fa24.svg";